/*
 * Model class Dials
 */
export default class Dials {
	constructor(size_large, size_small, content, colors) {
		this.size_large = size_large;
		this.size_small = size_small;
		this.risk_colors = colors;

		this.content = content;
	}

	set_dial_properties(risk) {
		var color = this.risk_colors[0],
			text  = this.content['risk-level-dial-txt-low'],
			index = 0;

		switch (risk) {
			case 'medium':
				color = this.risk_colors[1];
				text = this.content['risk-level-dial-txt-medium'];
                index = 1;
			break;

			case 'high':
				color = this.risk_colors[2];
				text = this.content['risk-level-dial-txt-high'];
                index = 2;
			break;
		}

		return {
			color	: color,
			text	: text.toUpperCase(),
            index 	: index
		};
	}

	simple_dial_options(value, risk, trackColor, trackWidth = 20, arcBorder = true, arcColor = '#FFFFFF') {
		var properties = this.set_dial_properties(risk);

		return {
			startAngle 		: -120,
			endAngle		: 120,
			displayPrevious	: false,
			trackColor		: trackColor,
			barColor		: properties.color,
			readOnly 		: true,
			trackWidth		: trackWidth,
			barWidth		: 10,
            middleArc		: {
                show : false,
                border: arcBorder,
                color: arcColor
            },
			arcOpacity 		: 0,
			size 			: this.size_small,
			displayNumber 	: {
				enabled 	: false
			},
			textMiddle 		: {
				enabled 		: true,
				text 			: properties.text,
				color 			: properties.color
			},
			subText			: {
				enabled			: false,
			},
			topBottomText 	: {
				enabled 		: false
			},
			scale			: {
				enabled			: false,
			},
			dynamicOptions	: true
		};
	}

	risk_level_dial(value, risk, trackColor = '#9B9B9B', trackWidth = 1, arcBorder = false, arcColor = '#FFFFFF') {
		var properties 	= this.set_dial_properties(risk),
			colors 		= ['#FFFFFF', '#FFFFFF', '#FFFFFF'];

		for (var i = 0; i <= properties.index; i++) {
			colors[i] = this.risk_colors[i];
		}

		var options = {
			startAngle 		: 180,
			endAngle		: 360,
			displayPrevious	: false,
			trackColor		: trackColor,
			barColor		: properties.color,
			readOnly 		: true,
			trackWidth		: trackWidth,
			barWidth		: 10,
			size			: this.size_large,
			middleArc		: {
				show : true,
				border: arcBorder,
				color: arcColor
			},
			arcOpacity 		: 1,
			displayType 	: 'monitor',
			displayDanger 	: {
				text 			: properties.text,
				colors 			: colors
			},
			displayNumber 	: {
				enabled 		: false
			},
			subText			: {
				enabled			: true,
				text			: this.content['risk-level-dial-txt-risk-level']
			},
			topBottomText 	: {
				enabled 		: true,
				topTxt 			: this.content['risk-level-dial-txt-high'].toUpperCase(),
				bottomTxt		: this.content['risk-level-dial-txt-low'].toUpperCase()
			},
			scale			: {
				enabled			: true,
				type			: 'lines',
				width			: 1,
				quantity		: 3
			}
		};

		return {
			value 	: value,
			options : options
		};
	}

	monitoring_dial(value, assetCount, barColor, trackColor = '#9B9B9B', trackWidth = 1, arcBorder = false, arcColor = '#FFFFFF') {
		var options = {
			startAngle 		: 180,
			endAngle		: 0.1,
			displayPrevious	: false,
			trackColor		: trackColor,
			barColor		: barColor,
			readOnly 		: true,
			trackWidth		: trackWidth,
			barWidth		: 10,
			size			: this.size_large,
            middleArc		: {
                show : true,
                border: arcBorder,
                color: arcColor
            },
			displayType 	: 'count',
			displayTxtItems	: this.content['monitoring-dial-txt-items'].toUpperCase(),
			arcOpacity 		: 1,
			displayNumber 	: {
				enabled 	: true,
				number 		: assetCount
			},
			subText			: {
				enabled			: true,
				text			: this.content['monitoring-dial-txt-monitoring']
			},
			topBottomText 	: {
				enabled 		: true,
				topTxt 			: this.content['monitoring-dial-txt-strong'].toUpperCase(),
				bottomTxt		: this.content['monitoring-dial-txt-weak'].toUpperCase()
			},
			scale			: {
				enabled			: true,
				type			: 'lines',
				width			: 1,
				quantity		: 3
			}
		};

		return {
			value 	: value,
			options : options
		};
	}

	small_dial(value, risk, trackColor = '#ECECEC') {
		return {
			value 	: value,
			options : this.simple_dial_options(value, risk, trackColor)
		};
	}
}
